"use client";

import { useActionState } from "react";
import { recoveryRequestAction, type RecoveryState } from "./actions";
import { Alert } from "@/components/ui/Alert";
import { Button } from "@/components/ui/Button";
import { FieldRow, Input } from "@/components/ui/Input";
import { useDict } from "@/components/i18n/DictProvider";

const initial: RecoveryState = { ok: false };

export function RecoveryForm() {
  const t = useDict();
  const [state, formAction, pending] = useActionState(recoveryRequestAction, initial);

  if (state.ok) {
    return <Alert tone="success">{t.auth.resetSent}</Alert>;
  }

  return (
    <form action={formAction} className="grid gap-4">
      {state.error ? <Alert tone="error">{state.error}</Alert> : null}
      <FieldRow label={t.auth.email}>
        <Input name="email" type="email" autoComplete="email" required className="rounded-xl" />
      </FieldRow>
      <Button type="submit" loading={pending} className="mt-1 w-full">
        {t.auth.sendResetLink}
      </Button>
    </form>
  );
}
